// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* I don't know how but I made it look pretty good. Please don't touch :D */

.loadingData1 {
    background-image: linear-gradient(90deg, #fff 0%, #fff 45%, #a3a3a3 48%,#a3a3a3 52%,#fff 55%,#fff 100% );
    background-attachment:fixed;
	background-position: 400% 50%;
    background-size: 120% 100%;
	animation: gradient 2s infinite;
	animation-delay: 0ms;
}
.loadingData2 {
    background-image: linear-gradient(90deg, #fff 0%, #fff 45%, #a3a3a3 48%,#a3a3a3 52%,#fff 55%,#fff 100% );
    background-attachment:fixed;
	background-position: 400% 50%;
    background-size: 120% 100%;
	animation: gradient 2s infinite;
	animation-delay: 50ms;
}
.loadingData3 {
    background-image: linear-gradient(90deg, #fff 0%, #fff 45%, #a3a3a3 48%,#a3a3a3 52%,#fff 55%,#fff 100% );
    background-attachment:fixed;
	background-position: 400% 50%;
    background-size: 120% 100%;
	animation: gradient 2s infinite;
	animation-delay: 100ms;
}
.loadingData4 {
    background-image: linear-gradient(90deg, #fff 0%, #fff 45%, #a3a3a3 48%,#a3a3a3 52%,#fff 55%,#fff 100% );
    background-attachment:fixed;
	background-position: 400% 50%;
    background-size: 120% 100%;
	animation: gradient 2s infinite;
	animation-delay: 150ms;
}
.loadingData5 {
    background-image: linear-gradient(90deg, #fff 0%, #fff 45%, #a3a3a3 48%,#a3a3a3 52%,#fff 55%,#fff 100% );
    background-attachment:fixed;
	background-position: 400% 50%;
    background-size: 120% 100%;
	animation: gradient 2s infinite;
	animation-delay: 200ms;
}
.loadingData6 {
    background-image: linear-gradient(90deg, #fff 0%, #fff 45%, #a3a3a3 48%,#a3a3a3 52%,#fff 55%,#fff 100% );
    background-attachment:fixed;
	background-position: 400% 50%;
    background-size: 120% 100%;
	animation: gradient 2s infinite;
	animation-delay: 250ms;
}
.loadingData7 {
    background-image: linear-gradient(90deg, #fff 0%, #fff 45%, #a3a3a3 48%,#a3a3a3 52%,#fff 55%,#fff 100% );
    background-attachment:fixed;
	background-position: 400% 50%;
    background-size: 120% 100%;
	animation: gradient 2s infinite;
	animation-delay: 300ms;
}
.loadingData8 {
    background-image: linear-gradient(90deg, #fff 0%, #fff 45%, #a3a3a3 48%,#a3a3a3 52%,#fff 55%,#fff 100% );
    background-attachment:fixed;
	background-position: 400% 50%;
    background-size: 120% 100%;
	animation: gradient 2s infinite;
	animation-delay: 350ms;

}

@keyframes gradient {
	0% {
		background-position: 400% 50%;
	}
	50% {
		background-position: -280% 50%;
	}
	100% {
		background-position: 400% 50%;
	}
}`, "",{"version":3,"sources":["webpack://./src/styles/Loading.css"],"names":[],"mappings":"AAAA,2EAA2E;;AAE3E;IACI,wGAAwG;IACxG,2BAA2B;CAC9B,6BAA6B;IAC1B,0BAA0B;CAC7B,+BAA+B;CAC/B,oBAAoB;AACrB;AACA;IACI,wGAAwG;IACxG,2BAA2B;CAC9B,6BAA6B;IAC1B,0BAA0B;CAC7B,+BAA+B;CAC/B,qBAAqB;AACtB;AACA;IACI,wGAAwG;IACxG,2BAA2B;CAC9B,6BAA6B;IAC1B,0BAA0B;CAC7B,+BAA+B;CAC/B,sBAAsB;AACvB;AACA;IACI,wGAAwG;IACxG,2BAA2B;CAC9B,6BAA6B;IAC1B,0BAA0B;CAC7B,+BAA+B;CAC/B,sBAAsB;AACvB;AACA;IACI,wGAAwG;IACxG,2BAA2B;CAC9B,6BAA6B;IAC1B,0BAA0B;CAC7B,+BAA+B;CAC/B,sBAAsB;AACvB;AACA;IACI,wGAAwG;IACxG,2BAA2B;CAC9B,6BAA6B;IAC1B,0BAA0B;CAC7B,+BAA+B;CAC/B,sBAAsB;AACvB;AACA;IACI,wGAAwG;IACxG,2BAA2B;CAC9B,6BAA6B;IAC1B,0BAA0B;CAC7B,+BAA+B;CAC/B,sBAAsB;AACvB;AACA;IACI,wGAAwG;IACxG,2BAA2B;CAC9B,6BAA6B;IAC1B,0BAA0B;CAC7B,+BAA+B;CAC/B,sBAAsB;;AAEvB;;AAEA;CACC;EACC,6BAA6B;CAC9B;CACA;EACC,8BAA8B;CAC/B;CACA;EACC,6BAA6B;CAC9B;AACD","sourcesContent":["/* I don't know how but I made it look pretty good. Please don't touch :D */\n\n.loadingData1 {\n    background-image: linear-gradient(90deg, #fff 0%, #fff 45%, #a3a3a3 48%,#a3a3a3 52%,#fff 55%,#fff 100% );\n    background-attachment:fixed;\n\tbackground-position: 400% 50%;\n    background-size: 120% 100%;\n\tanimation: gradient 2s infinite;\n\tanimation-delay: 0ms;\n}\n.loadingData2 {\n    background-image: linear-gradient(90deg, #fff 0%, #fff 45%, #a3a3a3 48%,#a3a3a3 52%,#fff 55%,#fff 100% );\n    background-attachment:fixed;\n\tbackground-position: 400% 50%;\n    background-size: 120% 100%;\n\tanimation: gradient 2s infinite;\n\tanimation-delay: 50ms;\n}\n.loadingData3 {\n    background-image: linear-gradient(90deg, #fff 0%, #fff 45%, #a3a3a3 48%,#a3a3a3 52%,#fff 55%,#fff 100% );\n    background-attachment:fixed;\n\tbackground-position: 400% 50%;\n    background-size: 120% 100%;\n\tanimation: gradient 2s infinite;\n\tanimation-delay: 100ms;\n}\n.loadingData4 {\n    background-image: linear-gradient(90deg, #fff 0%, #fff 45%, #a3a3a3 48%,#a3a3a3 52%,#fff 55%,#fff 100% );\n    background-attachment:fixed;\n\tbackground-position: 400% 50%;\n    background-size: 120% 100%;\n\tanimation: gradient 2s infinite;\n\tanimation-delay: 150ms;\n}\n.loadingData5 {\n    background-image: linear-gradient(90deg, #fff 0%, #fff 45%, #a3a3a3 48%,#a3a3a3 52%,#fff 55%,#fff 100% );\n    background-attachment:fixed;\n\tbackground-position: 400% 50%;\n    background-size: 120% 100%;\n\tanimation: gradient 2s infinite;\n\tanimation-delay: 200ms;\n}\n.loadingData6 {\n    background-image: linear-gradient(90deg, #fff 0%, #fff 45%, #a3a3a3 48%,#a3a3a3 52%,#fff 55%,#fff 100% );\n    background-attachment:fixed;\n\tbackground-position: 400% 50%;\n    background-size: 120% 100%;\n\tanimation: gradient 2s infinite;\n\tanimation-delay: 250ms;\n}\n.loadingData7 {\n    background-image: linear-gradient(90deg, #fff 0%, #fff 45%, #a3a3a3 48%,#a3a3a3 52%,#fff 55%,#fff 100% );\n    background-attachment:fixed;\n\tbackground-position: 400% 50%;\n    background-size: 120% 100%;\n\tanimation: gradient 2s infinite;\n\tanimation-delay: 300ms;\n}\n.loadingData8 {\n    background-image: linear-gradient(90deg, #fff 0%, #fff 45%, #a3a3a3 48%,#a3a3a3 52%,#fff 55%,#fff 100% );\n    background-attachment:fixed;\n\tbackground-position: 400% 50%;\n    background-size: 120% 100%;\n\tanimation: gradient 2s infinite;\n\tanimation-delay: 350ms;\n\n}\n\n@keyframes gradient {\n\t0% {\n\t\tbackground-position: 400% 50%;\n\t}\n\t50% {\n\t\tbackground-position: -280% 50%;\n\t}\n\t100% {\n\t\tbackground-position: 400% 50%;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
